import React from 'react';
import ReactTooltip from 'react-tooltip';
// import Slider from 'react-slick';
// import Carousel, { Dots } from '@brainhubeu/react-carousel';

// import '@brainhubeu/react-carousel/lib/style.css';

export default props => {
  const { data } = props;
  if (!data.locationPhotos || !data.locationPhotos.length) return null;

  const photos = data.locationPhotos;
  return (
    <div className="section">
      <h3 className="sectiontitle">Location photos</h3>

      <div className="sectionitem" style={{ fontVariant: 'normal !important' }}>
        <div className="leftrow wrap" style={{}}>
          {photos.map((photo, i) => {
            if (!photo.caption) return null;
            return (
              <ReactTooltip
                key={`tooltip${i}`}
                id={`photo${i}`}
                place="bottom"
                effect="solid"
                type="info"
              >
                <div style={{ maxWidth: '250px' }}>
                  <span>{photo.caption}</span>
                </div>
              </ReactTooltip>
            );
          })}
          {photos.map((photo, i) => (
            <img
              key={i}
              style={{ margin: '2px' }}
              data-tip
              data-for={`photo${i}`}
              src={photo.photo}
              alt={'Photo ' + i}
              className="photo-pop"
            />
          ))}
        </div>
      </div>
    </div>
  );

  // <div
  //   className="captioned"
  //   style={{
  //     flex: 1,
  //     minWidth: '250px',
  //     backgroundImage: `url(${photo.photo})`,
  //     backgroundPosition: 'center',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundSize: 'contain',
  //   }}
  // >
  //   <p className="caption">{photo.caption}</p>
  // </div>

  // <div style={{ width: '100%', height: '300px' }}>
  //   <Slider {...settings}>
  //     {photos.map((photo, i) => {
  //       return (
  //         <div
  //           style={{
  //             width: '100%',
  //             height: '100%',
  //             backgroundImage: `url(${photo.photo})`,
  //             backgroundPosition: 'center',
  //             backgroundRepeat: 'no-repeat',
  //             backgroundSize: 'contain',
  //           }}
  //         />
  //       );
  //     })}
  //   </Slider>
  // </div>
};
